import React from 'react';
import { observer } from 'mobx-react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {DailyDealContainerBox} from "./boxes/daily-deal-container.box";
import {DailyDealChestGlowBox} from "./boxes/daily-deal-chest-glow.box";
import {DailyDealChestBox} from "./boxes/daily-deal-chest.box";
import {DailyDealTextStripBox} from "./boxes/daily-deal-text-strip.box";
import {DailyDealChestHaloBox} from "./boxes/daily-deal-chest-halo.box";

@observer
export class DailyDealComponent extends OrbitComponent {

    componentDidMount(){
        if (this.services.dailyDeal.dailyDealCampaignId) {
            this.services.analytics.sendAnalytics('Daily_Deal', 'View', this.services.arenas.getCurrentArena().arenaName);
        }
    }

    render() {

        if (!this.services.dailyDeal.dailyDealCampaignId) {
            return null;
        }

        return (
            <DailyDealContainerBox onClick={this._onDailyDealClick} className="cy-daily-deal-box">
                    <DailyDealChestGlowBox />
                    <DailyDealChestHaloBox />
                    <DailyDealTextStripBox> {this.services.translation.translate("DAILY_DEAL_WIDGET_STRIP") } </DailyDealTextStripBox>
                    <DailyDealChestBox src={this.services.theme.currentTheme.images.dailyDeal.chest.toString()} alt="DailyDeal Chest!"/>
            </DailyDealContainerBox>
        );
    }

    private _onDailyDealClick = () => {
        this.services.analytics.sendAnalytics('Daily_Deal', 'Click', this.services.arenas.getCurrentArena().arenaName);
        this.services.dailyDeal.visitDailyDeal();
    }
}
